// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"59482e30","160":"47ba4651","208":"5b587f88","293":"e16d993f","516":"8eb9a9d7","519":"186c2602","917":"fa852272","946":"0db8fb43"}[chunkId] + ".chunk.js";
};